import React from 'react'
import { DeviceData } from '@/hooks/useDeviceSelection'

// Types for devices in test state management
export interface DevicesInTestState {
  selectedDevices: DeviceData[]
  isLoading: boolean
  error: string | null
  activeStep: number
  requestStatuses: Map<
    string,
    { status: 'success' | 'error' | 'loading'; message?: string }
  >
}

export type DevicesInTestAction =
  | { type: 'SET_SELECTED_DEVICES'; payload: DeviceData[] }
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_ERROR'; payload: string | null }
  | { type: 'SET_ACTIVE_STEP'; payload: number }
  | {
      type: 'SET_REQUEST_STATUS'
      payload: {
        uid: string
        status: { status: 'success' | 'error' | 'loading'; message?: string }
      }
    }
  | { type: 'RESET' }

export const initialDevicesInTestState: DevicesInTestState = {
  selectedDevices: [],
  isLoading: false,
  error: null,
  activeStep: 1,
  requestStatuses: new Map(),
}

export const devicesInTestReducer = (
  state: DevicesInTestState,
  action: DevicesInTestAction,
): DevicesInTestState => {
  switch (action.type) {
    case 'SET_SELECTED_DEVICES':
      return { ...state, selectedDevices: action.payload }
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload }
    case 'SET_ERROR':
      return { ...state, error: action.payload }
    case 'SET_ACTIVE_STEP':
      return { ...state, activeStep: action.payload }
    case 'SET_REQUEST_STATUS': {
      const newStatuses = new Map(state.requestStatuses)
      newStatuses.set(action.payload.uid, action.payload.status)
      return { ...state, requestStatuses: newStatuses }
    }
    case 'RESET':
      return initialDevicesInTestState
    default:
      return state
  }
}

// Context for sharing state between components
export interface DevicesInTestContextType {
  state: DevicesInTestState
  dispatch: React.Dispatch<DevicesInTestAction>
  onStopDurationTest: () => Promise<void>
  onBackToStep1: () => void
}

export const DevicesInTestContext =
  React.createContext<DevicesInTestContextType | null>(null)
